<template>
  <tr :key="item.id" :class="{'is-archived': isArchived}">
    <td>{{ item.code }}</td>
    <td>{{ item.name }}</td>
    <td style="width: 60%; position: relative">
      <CostCentersCenterCalendarsModal
        v-if="isShowModal"
        :calendars="calendars"
        :selected-ids="selectedIds"
        @close="isShowModal = false"
        @submit="onModalSubmit"
      />
      <div class="cost-center-actions">
        <div
          class="click-container"
          @click.capture.stop.prevent="isShowModal = true"
          v-if="!isInSchoolSalarySettings && !isArchived">
          <DoFiltersFilter
            :title="'Kalendere'"
            :tags="calendarNames"
            :numberOfSelectedTagsToShow="20"
            :selectedTags="selectedNames"
            @select="noop"
            @clear="noop"
            @close="noop"
          />
        </div>
        <button
          v-if="!isArchived"
          class="do-bttn do-bttn--small"
          :class="{'do-bttn--loading': isUpdating}"
          @click.stop="$emit('archive', item)">
          Arkivér
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import DoFiltersFilter from '../../DoFilters/DoFiltersFilter.vue'
import CostCentersCenterCalendarsModal from './CostCentersCenterCalendarsModal.vue'

export default {
  components: { CostCentersCenterCalendarsModal, DoFiltersFilter },
  props: {
    item: {
      type: Object,
      required: true
    },
    calendars: {
      type: Array,
      default: () => [] // [{ id, name, type? }]
    },
    calendarNames: {
      type: Array,
      default: () => [] // bruges kun til filterets "tags"-visning
    },
    initialSelectedCalendarIds: {
      type: Array,
      default: () => []
    },
    isInSchoolSalarySettings: {
      type: Boolean,
      default: true
    },
    isUpdating: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowModal: false,
      selectedIds: [],
      lastEmittedIds: []
    }
  },
  computed: {
    isArchived () {
      return !!(this.item && (this.item.archived === true || this.item.archived_at))
    },
    selectedNames () {
      const ids = this.selectedIds
      return ids
        .map(id => {
          const cal = this.calendars.find(c => c.id === id)
          return cal ? cal.name : null
        })
        .filter(n => n !== null)
    }
  },
  methods: {
    arraysEqual (a, b) {
      const aa = (a || []).slice().sort()
      const bb = (b || []).slice().sort()
      if (aa.length !== bb.length) return false
      for (let i = 0; i < aa.length; i++) {
        if (aa[i] !== bb[i]) return false
      }
      return true
    },
    onModalSubmit (ids) {
      this.isShowModal = false

      // kun emit, hvis der faktisk er ændringer
      if (this.arraysEqual(ids, this.lastEmittedIds)) return

      this.selectedIds = ids.slice()
      this.lastEmittedIds = ids.slice()

      const payload = {
        type: 'calendars',
        calendar_ids: ids,
        selected_cost_center_id: this.item.id
      }
      this.$emit('save', payload)
    },
    noop () {
      // DoFiltersFilter er her kun som "visning", så vi ignorerer events
      return
    }
  },
  mounted () {
    // init state fra props
    this.selectedIds = Array.isArray(this.initialSelectedCalendarIds) ? this.initialSelectedCalendarIds.slice() : []
    this.lastEmittedIds = this.selectedIds.slice()
  }
}
</script>

<style scoped>
.cost-center-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  width: 100%;
}

.do-bttn.do-bttn--small {
  font-size: 11px;
  height: auto;
  padding: 5px 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.is-archived {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// CostCentersCenter.vue?71ddb709